import { Col, Layout, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Header from "../Authorized/Header";
import constants from "../Redux/constants";
import {
  getCurrentJobs,
  // getApplicationById,
} from "../Redux/Consultant/reducer";
import { getOfferProgress } from "../Redux/User/reducer";
import { StyledLink } from "../styled-components/components";
import Feedback from "../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet";
import ConsultantProfileCompletion from "./Profile/ConsultantProfileCompletion";

const ActiveJobs = (props) => {
  const [loading, setLoading] = useState(true);
  const { getCurrentJobs, getOfferProgress } = props;
  useEffect(() => {
    const fetchCurrentJobs = async () => {
      const { responseStatus } = await getCurrentJobs();
      if (responseStatus === constants.status.success) {
        setLoading(false);
      }
    };
    fetchCurrentJobs();
    return () => {
      setLoading(true);
    };
  }, [getCurrentJobs]);
  const { currentJobs } = useSelector((state) => state.consultantStore);
  return (
    <Layout>
      <Helmet title="Active Jobs | Unicon" />
      <Header></Header>
      <Layout.Content>
        <ConsultantProfileCompletion />
        {loading ? (
          <Feedback
            icon={<LoadingOutlined />}
            title="Fetching Current Jobs"
          ></Feedback>
        ) : (
          <Col xl={{ span: 16 }} style={{ margin: "auto" }}>
            {currentJobs.length > 0 ? (
              <Col>
                {currentJobs.map((job) => (
                  <JobCard
                    key={job.offerId}
                    title={job.title}
                    offerId={job.offerId}
                    jobId={job.jobId}
                    getOfferProgress={getOfferProgress}
                    applicationId={job.applicationId}
                  ></JobCard>
                ))}
              </Col>
            ) : (
              <Col
                md={{ span: 11 }}
                style={{
                  padding: "1vh",
                  background: "#ffffff",
                  border: "1px solid #f4f4f4",
                  margin: "2vh",
                  marginLeft: "auto",
                  marginRight: "auto",
                  borderRadius: "2vh",
                }}
              >
                <Feedback status="404" title="No Active Jobs Found!" />
              </Col>
            )}
          </Col>
        )}
      </Layout.Content>
    </Layout>
  );
};

const JobCard = (props) => {
  const history = useHistory();
  const { offerId, jobId } = props;
  const showProgress = async () => {
    history.push(`/job/${jobId}/progress/${offerId}`);
  };
  return (
    <Col
      style={{
        padding: "2vh",
        background: "#ffffff",
        border: "1px solid #f4f4f4",
        margin: "2vh",
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: "4px",
      }}
    >
      <Row>
        <Typography.Title level={4}>{props.title}</Typography.Title>
      </Row>
      <Row>
        <StyledLink onClick={showProgress}>Update Progress</StyledLink>
      </Row>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCurrentJobs: () => dispatch(getCurrentJobs()),
    getOfferProgress: (applicationId) =>
      dispatch(getOfferProgress(applicationId)),
  };
};

export default connect(null, mapDispatchToProps)(ActiveJobs);
